import React from 'react'

import { Decorators } from 'components/RichTextEditor/decorators/useDecorators'

import SimpleDecoratorTool from '../formattingToolbar/items/SimpleDecoratorTool'
import ToggleTool from '../formattingToolbar/items/ToggleTool'
import { SliceType } from '../slice/types'
import { IToolHandler } from '../types'

import { Tools } from './toolbarInterfaces'

export interface IProps {
  decorators: Decorators
  onInsert: IToolHandler
  selectedTool: string | null
  onSelectTool: (tool: string | null) => void
}

const stopPropagationFn = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation()
  e.preventDefault()
}

const TelegramRichTextToolbar = ({ decorators, onInsert, selectedTool, onSelectTool }: IProps) => {
  return (
    <div
      className="d-flex flex-row align-center"
      onClick={stopPropagationFn}
      onMouseDown={stopPropagationFn}
    >
      <ToggleTool
        tool={Tools.smartLinks}
        selectedTool={selectedTool}
        onSelect={onSelectTool}
        onInsert={onInsert}
      />
      <SimpleDecoratorTool
        decorators={decorators}
        decoratorType={SliceType.BOLD}
        className="m-l-xxs"
      />
      <SimpleDecoratorTool
        decorators={decorators}
        decoratorType={SliceType.ITALIC}
        className="m-l-xxs"
      />
      <SimpleDecoratorTool
        decorators={decorators}
        decoratorType={SliceType.UNDERLINE}
        className="m-l-xxs"
      />
    </div>
  )
}

export default TelegramRichTextToolbar
